"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _radialBar = require("@nivo/radial-bar");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var _default = exports["default"] = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_radialBar.ResponsiveRadialBar, _extends({
    data: [],
    valueFormat: ">-.2f",
    padding: 0.4,
    cornerRadius: 2,
    margin: {
      top: 40,
      right: 120,
      bottom: 40,
      left: 40
    },
    radialAxisStart: {
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0
    },
    circularAxisOuter: {
      tickSize: 5,
      tickPadding: 12,
      tickRotation: 0
    },
    legends: [{
      anchor: 'right',
      direction: 'column',
      justify: false,
      translateX: 80,
      translateY: 0,
      itemsSpacing: 6,
      itemDirection: 'left-to-right',
      itemWidth: 100,
      itemHeight: 18,
      itemTextColor: '#999',
      symbolSize: 18,
      symbolShape: 'square',
      effects: [{
        on: 'hover',
        style: {
          itemTextColor: '#000'
        }
      }]
    }]
  }, props));
};